module.exports = __webpack_public_path__ + "img/max-file-deny--zip.f5a70761.svg";